import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { XCircle } from 'lucide-react';

export const RegistrationLoading = () => (
  <div className="min-h-screen bg-linear-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500"></div>
  </div>
);

export const RegistrationError = ({ error, onNavigate }) => (
  <div className="min-h-screen bg-linear-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
    <Card className="max-w-md w-full bg-gray-800 border-gray-700">
      <CardContent className="pt-6">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto">
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-2xl font-bold text-white">Invalid Registration Link</h2>
          <p className="text-gray-400">
            {error || 'This registration link is invalid or has expired.'}
          </p>
          <Button onClick={onNavigate} className="bg-emerald-600 hover:bg-emerald-700">
            Return to Home
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
);
